import React, { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  ImageList,
  ImageListItem,
  Dialog,
  IconButton,
  Fade,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const DestinoGaleria = ({ imagenes = [] }) => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  if (imagenes.length === 0) return null;

  const abrir = (i) => {
    setIndex(i);
    setOpen(true);
  };

  const siguiente = () => {
    setIndex((prev) => (prev + 1) % imagenes.length);
  };

  const anterior = () => {
    setIndex((prev) =>
      prev === 0 ? imagenes.length - 1 : prev - 1
    );
  };

  return (
    <Paper
      sx={{
        mt: 5,
        p: 3,
        borderRadius: 4,
        boxShadow: 8,
      }}
    >
      <Typography
        variant="h5"
        fontWeight="bold"
        color="primary"
        mb={3}
      >
        Galería
      </Typography>

      <ImageList
            cols={2}
            gap={12}
            rowHeight={220}
            sx={{
                width: "100%",
                margin: 0,

                "& .MuiImageListItem-root": {
                    borderRadius: 3,
                    overflow: "hidden",
                }
            }}
        >
        {imagenes.slice(0, 4).map((img, i) => {
          const restantes = imagenes.length - 4;
          const ultima = i === 3 && restantes > 0;

          return (
            <ImageListItem
              key={img.id}
              onClick={() => abrir(i)}
              sx={{
                cursor: "pointer",
                position: "relative",
                overflow: "hidden",
                borderRadius: 3,
              }}
            >
             <Box
                sx={{
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                    borderRadius: 3,
                    bgcolor: "#f3f3f3",
                }}
            >
                <img
                    src={img.imagen}
                    alt=""
                    loading="lazy"
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                        transition: "transform .35s ease",
                    }}
                    onMouseOver={(e) => {
                        e.currentTarget.style.transform = "scale(1.08)";
                    }}
                    onMouseOut={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                    }}
                />
              </Box>

              {ultima && (
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    bgcolor: "rgba(0,0,0,.45)",
                    backdropFilter: "blur(4px)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: 42,
                  }}
                >
                  +{restantes}
                </Box>
              )}
            </ImageListItem>
          );
        })}
      </ImageList>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="xl"
        fullWidth
        TransitionComponent={Fade}
        PaperProps={{
          sx: {
            bgcolor: "transparent",
            boxShadow: "none",
          },
        }}
        BackdropProps={{
          sx: {
            bgcolor: "rgba(0,0,0,.45)",
            backdropFilter: "blur(8px)",
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "90vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              top: 20,
              right: 20,
              bgcolor: "rgba(255,255,255,.9)",
              "&:hover": {
                bgcolor: "#fff",
              },
              zIndex: 10,
            }}
          >
            <CloseIcon />
          </IconButton>

          <IconButton
            onClick={anterior}
            sx={{
              position: "absolute",
              left: 20,
              top: "50%",
              transform: "translateY(-50%)",
              bgcolor: "rgba(255,255,255,.9)",
              "&:hover": {
                bgcolor: "#fff",
              },
            }}
          >
            <ArrowBackIosNewIcon />
          </IconButton>

          <img
            src={imagenes[index].imagen}
            alt=""
            style={{
              maxWidth: "92%",
              maxHeight: "88vh",
              objectFit: "contain",
              borderRadius: "18px",
              boxShadow: "0 20px 60px rgba(0,0,0,.4)",
            }}
          />

          <IconButton
            onClick={siguiente}
            sx={{
              position: "absolute",
              right: 20,
              top: "50%",
              transform: "translateY(-50%)",
              bgcolor: "rgba(255,255,255,.9)",
              "&:hover": {
                bgcolor: "#fff",
              },
            }}
          >
            <ArrowForwardIosIcon />
          </IconButton>

          <Typography
            sx={{
              position: "absolute",
              bottom: 25,
              left: "50%",
              transform: "translateX(-50%)",
              color: "#fff",
              bgcolor: "rgba(0,0,0,.5)",
              px: 2,
              py: 1,
              borderRadius: 10,
              fontWeight: "bold",
            }}
          >
            {index + 1} / {imagenes.length}
          </Typography>
        </Box>
      </Dialog>
    </Paper>
  );
};

export default DestinoGaleria;